import React, {useMemo, useCallback, useState} from "react"
import './nav-bar-sort-menu.css';
import {useSelector} from "react-redux";
import WithSuspense from "../repeating-components/wrapper-components/with-suspense";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import {getQueryLinkParams} from "../../helpers/routing-helper";
import {useLocation} from "react-router-dom";
import PropTypes from 'prop-types';

// Оптимизированные импорты lodash
import find from "lodash/find";
import split from "lodash/split";
import filter from "lodash/filter";

const AuctionCategoryBlock = React.lazy(() => import('./auction-category-block'));
const OwnerCategoryBlock = React.lazy(() => import('./owner-category-block'));
const SearchBlock = React.lazy(() => import('./search-block'));
const AvatarBlock = React.lazy(() => import('./avatar-block'));
const ArchiveSwitchBlock = React.lazy(() => import('./archive-switch-block'));

const USER_LOT_TYPES = ['archive_lots', 'auction_lots', 'user_lots'];
const SUBSCRIPTIONS_ROUTE = 'subscriptions';

const NavBarSortMenu = React.memo(() => {
    const location = useLocation();

    const selector = useMemo(() => (state) => {
        const {lots} = state;
        const arr = filter(split(location.pathname, '/', 2), Boolean);
        const {user_lots_type, auction_category_id} = getQueryLinkParams();

        return {
            user_lots_type,
            auction_category_id,
            routeName: (arr.length > 0) ? arr[0] : '',
            all_categories: lots.all_categories,
            searchAuctions: lots.visitor.permissions.auctions,
            ak_au_ph_sort_by_category: lots.phrases.ak_au_ph_sort_by_category
        }
    }, [location.pathname]);

    const {searchAuctions, all_categories, ak_au_ph_sort_by_category, user_lots_type, auction_category_id, routeName} = useSelector(selector);

    const shouldShowCategoryBlock = useMemo(() => {
        return routeName !== SUBSCRIPTIONS_ROUTE && USER_LOT_TYPES.includes(user_lots_type);
    }, [routeName, user_lots_type]);

    const categoryBlock = useMemo(() => {
        if (!shouldShowCategoryBlock) return null;

        let categoryTitle = ak_au_ph_sort_by_category;

        if (auction_category_id !== 0) {
            const {category_title} = find(all_categories, {auction_category_id});
            categoryTitle = category_title
        }

        return user_lots_type === 'user_lots'
            ? <OwnerCategoryBlock category_title={categoryTitle}/>
            : <AuctionCategoryBlock category_title={categoryTitle}/>;

    }, [shouldShowCategoryBlock, auction_category_id, user_lots_type, all_categories, ak_au_ph_sort_by_category]);


    const searchBlock = useMemo(() =>
        searchAuctions ? <SearchBlock/> : null,
        [searchAuctions]
    );
    const avatarBlock = useMemo(() =>
        user_lots_type === 'archive_lots' ? <ArchiveSwitchBlock/> : <AvatarBlock/>,
        [user_lots_type]
    );

    const wrapper = useCallback((component) => {
        return <WithSuspense>{component}</WithSuspense>
    }, []);
    

    return (
        <Navbar className="rounded m-1 nav-bar-sort-menu" collapseOnSelect expand="lg" bg={"success"} variant={"dark"}>
            <Container>
                {wrapper(avatarBlock)}
                <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">

                    </Nav>
                    <div className="d-flex align-items-center">
                        {wrapper(categoryBlock)}
                        {wrapper(searchBlock)}
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
});

export default NavBarSortMenu;